import { render, staticRenderFns } from "./QuestionStatisticsItem.vue?vue&type=template&id=7296ab72&scoped=true"
import script from "./QuestionStatisticsItem.vue?vue&type=script&lang=ts"
export * from "./QuestionStatisticsItem.vue?vue&type=script&lang=ts"
import style0 from "./QuestionStatisticsItem.vue?vue&type=style&index=0&id=7296ab72&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7296ab72",
  null
  
)

export default component.exports